module.exports = __webpack_public_path__ + "img/s00166.7ddccb10.png";